import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetCouriersParams,
    GetCouriersResponse,
    GetCourierResponse,
    CourierPayload,
    GetCourierScheduleTypesResponse,
    GetScheduleTypesParams,
    GetTakeCouriersParams,
    GetTakeCouriersResponse,
    CouriersExportExcelParamsT,
    CouriersExportExcelResponseT,
    GetCouriersReportsParams,
    GetCouriersReportsResponse,
    CourierReportCloseDayPayload,
    CloseDayResponse,
    GetCourierReportDetailsResponse,
    GetCourierScheduleResponse,
    GetProvidersResponse,
    GetProvidersParams,
    GetCodeResponse,
} from '@/new-services/types/couriers'

type ApiGetCouriersResponse = Promise<AxiosResponse<GetCouriersResponse>>
type ApiGetProvidersResponse = Promise<AxiosResponse<GetProvidersResponse>>
type ApiGetCourierResponse = Promise<AxiosResponse<GetCourierResponse>>
type ApiUpdateCourierResponse = Promise<AxiosResponse<void>>
type ApiSetPhoneResponse = Promise<AxiosResponse<void>>
type ApiGetCourierScheduleTypesResponse = Promise<AxiosResponse<GetCourierScheduleTypesResponse>>
type ApiGetTakeCouriersResponse = Promise<AxiosResponse<GetTakeCouriersResponse>>
type ApiExportExcelResponse = Promise<AxiosResponse<CouriersExportExcelResponseT>>
type ApiGetCouriersReportsResponse = Promise<AxiosResponse<GetCouriersReportsResponse>>
type ApiGetCourierReportDetailsResponse = Promise<AxiosResponse<GetCourierReportDetailsResponse>>
type ApiCloseDayResponse = Promise<AxiosResponse<CloseDayResponse>>
type ApiGetCourierScheduleResponse = Promise<AxiosResponse<GetCourierScheduleResponse>>
type ApiGetCodeResponse = Promise<AxiosResponse<GetCodeResponse>>
type ApiGetQrResponse = Promise<AxiosResponse<string>>
type ApiCreateRouteResponse = Promise<AxiosResponse<void>>
type ApiManageRoutingResponse = Promise<AxiosResponse<void>>

export function getCouriers(params: GetCouriersParams): ApiGetCouriersResponse {
    return http.get('/dispatcher/api/couriers', { params })
}

export function getProviders(params: GetProvidersParams): ApiGetProvidersResponse {
    return http.get('/delivery/api/providers', { params })
}

export function getTakeCouriers(params: GetTakeCouriersParams): ApiGetTakeCouriersResponse {
    return http.get('/dispatcher/api/couriers/take-list', { params })
}

export function getCourier(courier_id: number): ApiGetCourierResponse {
    return http.get(`/dispatcher/api/couriers/${courier_id}`)
}

export function updateCourier(
    courier_id: number,
    payload: CourierPayload
): ApiUpdateCourierResponse {
    return http.put(`/dispatcher/api/couriers/${courier_id}`, payload)
}

export function setPhone(id: number, phoneNumber: string): ApiSetPhoneResponse {
    return http.put(`/dispatcher/api/couriers/${id}/set-phone`, { phoneNumber })
}

export function getCourierScheduleTypes(
    params: GetScheduleTypesParams
): ApiGetCourierScheduleTypesResponse {
    return http.get('/dispatcher/api/courier-schedule-types', { params })
}

export function exportExcel(params: CouriersExportExcelParamsT): ApiExportExcelResponse {
    return http.get('/dispatcher/api/couriers/export', { responseType: 'blob', params })
}

export function getCouriersReports(
    params: GetCouriersReportsParams
): ApiGetCouriersReportsResponse {
    return http.get('/dispatcher/api/courier-report/end-of-day', { params })
}

export function getCourierReportDetails(
    courier_id: number,
    date: string
): ApiGetCourierReportDetailsResponse {
    return http.get(`/dispatcher/api/courier-report/${courier_id}/end-of-day`, {
        params: {
            date,
        },
    })
}

export function closeDay(
    courier_id: number,
    payload: CourierReportCloseDayPayload
): ApiCloseDayResponse {
    return http.post(`/dispatcher/api/courier-report/${courier_id}/close-day`, payload)
}

export function getCourierSchedule(courierId: number): ApiGetCourierScheduleResponse {
    return http.get(`/dispatcher/api/courier-schedule/${courierId}`, {
        params: {
            courierId,
        },
    })
}

export function getCode(phoneNumber: string): ApiGetCodeResponse {
    return http.get(`/gateway/code/${phoneNumber}`)
}

export function getQr(courierId: number): ApiGetQrResponse {
    return http.get(`/dispatcher/api/courier-app/courier-qr`, { params: { courierId } })
}

export function createRoute(courierId: number): ApiCreateRouteResponse {
    return http.post('/dispatcher/api/routing', {
        courierId,
    })
}

export function manageRouting(courierId: number, routingEnabled: number): ApiManageRoutingResponse {
    return http.put(`/dispatcher/api/couriers/${courierId}/routing`, {
        courierId,
        routingEnabled,
    })
}

export default {
    getCouriers,
    getProviders,
    getTakeCouriers,
    getCourier,
    updateCourier,
    getCourierScheduleTypes,
    exportExcel,
    getCouriersReports,
    getCourierReportDetails,
    closeDay,
    getCourierSchedule,
    setPhone,
    getCode,
    createRoute,
    manageRouting,
    getQr,
}
